module.exports = __webpack_public_path__ + "img/company.e184b12e.png";